import logoDark from "@/assets/logo-dark.png";
import logoLight from "@/assets/logo-light.png";

export function Wordmark({ className = "" }: { className?: string }) {
  return (
    <span className={`inline-flex items-center gap-2 font-semibold tracking-tightest ${className}`}>
      <span aria-hidden className="relative inline-flex h-6 w-6 shrink-0">
        <img
          src={logoLight}
          alt=""
          className="absolute inset-0 h-full w-full rounded-[7px] object-cover dark:hidden"
        />
        <img
          src={logoDark}
          alt=""
          className="absolute inset-0 hidden h-full w-full rounded-[7px] object-cover dark:block"
        />
      </span>
      <span className="text-[15px]">
        Super Affiliate <span className="text-primary">OS</span>
      </span>
    </span>
  );
}
